"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _NightsPicker = require("./NightsPicker.desktop");
var _NightsPicker2 = require("./NightsPicker.mobile");
var NightsPicker = function NightsPicker(props) {
  var isMobile = props.isMobile;
  return isMobile ? /*#__PURE__*/_react["default"].createElement(_NightsPicker2.NightsPickerMobile, (0, _extends2["default"])({}, props, {
    isMobile: true
  })) : /*#__PURE__*/_react["default"].createElement(_NightsPicker.NightsPickerDesktop, props);
};
var _default = exports["default"] = NightsPicker;